import { Injectable } from '@angular/core';
import { tasksStub } from './tasks-stub';

const userData: any = {
  firstName: 'Steve',
  lastName: 'McQueen',
  avatar: null,
  // avatar: 'http://blogs.cornell.edu/exlibris/files/2014/05/0111201286-Vonnegut-2jmtruq.jpg',
  userType: 'User type',
  progress: 0,
  initials: '',
  currentTasks: []
};


@Injectable()
export class AccountService {
  userModel: any = {};

  getCurrentTasks(): void {
    Promise.resolve(tasksStub).then(data => {
      this.userModel.currentTasks = data;
    });
  }

  getUser(): void {
    Promise.resolve(userData).then(data => {
      Object.assign(this.userModel, data);
      this.setUserInitials();
    });
  }

  setUserInitials(): void {
    if (!this.userModel.firstName && !this.userModel.lastName) {
      this.userModel.initials = '';
    }
    this.userModel.initials = this.userModel.firstName.charAt(0)
                             + this.userModel.lastName.charAt(0);
  }
}
